import React, { useState } from 'react'
import MenuBottom from '../../Component/menuBottom/MenuBottom'
import Shopping from '../Shopping/Shopping'
import WaitingForPay from '../WaitingForPay/WaitingForPay'
import Style from './ShoppingPart.module.css'
import { useTransferReasons } from '../../Context/TransferReasonContext'
const ShoppingPart = () => {
    const [checkedClass,setCheckdClass]=useState(false)
    const ClassHandler =()=>{
        setCheckdClass(false)
    }
    const ClassHandler2 =()=>{
        setCheckdClass(true)
    }
    let Content=null
    if(checkedClass) 
    {
        Content=<WaitingForPay/>
    }
    if(!checkedClass)
    {
        Content=<Shopping/>
    }
    const { userInfoData } = useTransferReasons();
    return (
        <div className={Style.PageHolder}>
            <header className={Style.TabsTitle}>
                <div className={checkedClass?Style.normal:Style.checked} onClick={ClassHandler}> سبدخرید </div>
                <div className={checkedClass?Style.checked:Style.normal} onClick={ClassHandler2}> در انتظار پرداخت {userInfoData?.awaiting_payment_order!=="0"&&<span className={Style.OrderCount}>{userInfoData?.awaiting_payment_order}</span>}</div>
            </header>
            {Content}
            <MenuBottom/>

        </div>
    )
}

export default ShoppingPart
